import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faCar, faHome, faShuttleVan, faTruckMoving,
    faBriefcase, faShieldAlt, faHardHat, faHouseDamage,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

// Homepage "Insurance Solutions We Offer" — clickable cards (icon + title + short
// description). All links resolve to live pages (General Liability points to the
// Business page, which covers GL, matching the Compare Rates menu).
const OFFERINGS = [
    { label: "Auto Insurance", to: "/auto-insurance-quote", icon: faCar, desc: "Affordable auto insurance options for California drivers." },
    { label: "Commercial Auto Insurance", to: "/commercial-auto-insurance", icon: faShuttleVan, desc: "Coverage for business vehicles, contractors, vans, trucks, and fleets." },
    { label: "Trucking Insurance", to: "/trucking-insurance", icon: faTruckMoving, desc: "Insurance options for box trucks, semis, owner-operators, and fleets." },
    { label: "Business Insurance", to: "/business-insurance", icon: faBriefcase, desc: "Coverage options for small businesses, contractors, offices, and service providers." },
    { label: "General Liability Insurance", to: "/business-insurance", icon: faShieldAlt, desc: "Protection for third-party injury, property damage, and business liability claims." },
    { label: "Workers Compensation", to: "/workers-compensation-insurance", icon: faHardHat, desc: "Required coverage for most California employers with employees." },
    { label: "Homeowners Insurance", to: "/home-owner-insurance", icon: faHome, desc: "Coverage for your home, personal property, and liability needs." },
    { label: "Earthquake Insurance", to: "/earthquake-insurance", icon: faHouseDamage, desc: "Coverage options for earthquake damage standard homeowners policies usually exclude." },
];

function SecondComponent() {
    return (
        <div className="container" style={{ paddingTop: "40px", paddingBottom: "40px" }}>
            <style>{`
                .solution-card{display:flex;flex-direction:column;align-items:center;text-align:center;height:100%;
                    background:#fff;border:1px solid #e6e9ef;border-radius:12px;padding:28px 18px;color:inherit;
                    text-decoration:none;transition:transform .18s ease, box-shadow .18s ease;
                    box-shadow:0 2px 10px rgba(19,32,66,.05);}
                .solution-card:hover{transform:translateY(-4px);box-shadow:0 10px 24px rgba(19,32,66,.12);
                    text-decoration:none;}
                .solution-card h3{font-size:1rem;font-weight:600;color:#132042;margin:14px 0 6px;}
                .solution-card p{font-size:.85rem;color:#6b7a90;margin:0;}
            `}</style>
            <div className="row">
                {OFFERINGS.map(({ label, to, icon, desc }) => (
                    <div className="col-lg-3 col-sm-6 mb-4" key={label}>
                        <Link to={to} className="solution-card" aria-label={label}>
                            <FontAwesomeIcon icon={icon} style={{ fontSize: "46px", color: "#1b75bc" }} />
                            <h3>{label}</h3>
                            <p>{desc}</p>
                        </Link>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default SecondComponent;
